<template>
  <div class="authentication-form">
    <h2
      class="authentication-form__heading u-typography-gilroy u-text-display  u-text-display--m u-text-display--bold"
    >
      {{ $t('dashboard.label.twoFactorAuthentication') }}
    </h2>
    <p class="authentication-form__info u-typography-gilroy u-text u-text--m">
      {{ $t('dashboard.authentication.openAuthenticationApp') }}
    </p>
    <u-form ref="authenticationForm" class="form" @submit.prevent="onSubmit">
      <u-input
        v-model="verificationCode"
        type="text"
        :label="$t('dashboard.label.sixDigitCode')"
        :validators="[validateCodeField]"
      />
      <u-button class="form__primary-button" type="submit" :loading="loading">
        {{ $t('dashboard.action.confirm') }}
      </u-button>

      <div
        v-if="authenticationError"
        class="form__error-message u-typography-gilroy u-text u-text--xs"
      >
        <u-icon name="alert-triangle" />
        {{ authenticationError }}
      </div>

      <div
        class="support-message authentication-form__support-message u-typography-gilroy u-text u-text--s"
      >
        <div class="support-message__paragraph">
          {{ $t('dashboard.landing.havingProblems') }}
        </div>
        <div
          class="support-message__link u-typography-gilroy u-text u-text--s u-text--link pointer mb10"
          @click="goToRecoveryCodePage"
        >
          {{ $t('dashboard.label.enterTwoFactorRecoveryCode') }}
        </div>
        <div class="support-message__paragraph">
          {{ $t('dashboard.label.orContactSupportBy') }}
          <a
            class="support-message__link text-underlined u-typography-gilroy u-text u-text--s u-text--link"
            href="mailto:info@universkin.com"
            >info@universkin.com</a
          >
        </div>
      </div>
    </u-form>
  </div>
</template>

<script>
import { UButton, UForm, UInput, UIcon } from 'universkin-shared';

import { getRequiredValidator } from 'universkin-shared/src/utils/validators';

export default {
  name: 'TwoFactorAuthenticationForm',
  components: { UButton, UForm, UInput, UIcon },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    authenticationError: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      verificationCode: '',
      validateCodeField: getRequiredValidator(this.$t('dashboard.authentication.filedRequired'))
    };
  },
  methods: {
    onSubmit() {
      this.$emit('submit-code', this.verificationCode);
    },
    goToRecoveryCodePage() {
      this.$emit('open-recovery-code-page');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~universkin-shared/src/assets/styles/scss/colors';
@import '~universkin-shared/src/assets/styles/scss/sizes';

.authentication-form {
  &__heading {
    width: 200px;
    margin: 0 0 10px 0;
  }

  &__info {
    color: $color-grey600;
    margin: 0 0 52px 0;
  }

  &__support-message {
    color: $color-grey600;
    margin-top: 20px;
  }
}

.form {
  display: flex;
  flex-direction: column;

  &__primary-button {
    margin-top: 24px;
  }

  &__error-message {
    color: $color-error;
    --u-icon-color: #{$color-error};
    margin-top: 5px;
    text-align: center;
  }
}

.support-message {
  &__paragraph:first-child {
    width: 100%;
    margin-bottom: 14px;
  }

  &__link {
    color: $color-graphite;
  }
}

.text-underlined {
  text-decoration: underline;
}

@media (min-width: 500px) and (max-width: 599px) {
  .authentication-form {
    padding: 0 30px;
  }
}

@media (min-width: $medium-start) {
  .authentication-form {
    max-width: 430px;
  }
}

@media (min-width: $desktop-start) {
  .authentication-form {
    max-width: 325px;

    &__info {
      margin-bottom: 36px;
    }
  }

  .support-message {
    &__paragraph:first-child {
      width: 240px;
      margin-bottom: 0;
    }
  }
}
</style>
